import Ajv, { JSONSchemaType, ValidateFunction } from 'ajv';

const ajv = new Ajv();

export type ValidationSuccessResult = { success: true };

export type ValidationErrorResult = {
    success: false;
    error: string;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    details?: any;
};

export type ValidationResult = ValidationSuccessResult | ValidationErrorResult;

export class AjvValidator<T> {
    private readonly validator: ValidateFunction<T>;

    public constructor(private schema: JSONSchemaType<T>) {
        this.validator = ajv.compile<T>(schema);
    }

    public validate(target: unknown): ValidationResult {
        if (this.validator(target)) {
            return { success: true };
        }

        const required =
            this.validator.errors &&
            this.validator.errors
                .filter((e) => e.keyword === 'required')
                .map((e) => e.params['missingProperty'])
                .join(',');
        const message = required
            ? `The following fields(s) are missing: ${required}`
            : this.validator.errors
            ? this.validator.errors
                  .map((e) => `${e.instancePath ?? e.schemaPath} ${e.message}`)
                  .join(',')
            : 'Invalid Json';

        return {
            success: false,
            error: message,
            details: { ...this.validator.errors },
        };
    }
}
